import { Component } from 'react';
/**
 * CollectionFolderDialog
 */
export const CollectionFolderDialog = (props) => false;
